<template>
  <v-col
    class="boxes-parent"
    cols="12"
    lg="8"
  >
    <v-row>
      <v-col
        v-for="(callBox, index) in callAnalytics"
        :key="index"
        cols="6"
        sm="4"
      >
        <icon-box
          :key="index"
          :call-box="callBox"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import { mapState } from 'pinia';

  import {
    loggedIn,
    availableAgents,
    activeCalls,
    averageTalkingTime,
    averageWaitingTime,
    waitingCalls,
  } from '@/assets/images/components/boxes/icon_box';
  import IconBox from '@/components/SharedComponents/Boxes/IconBox.vue';
  import { useDashboardStore } from '@/stores/reports/dashboard.store';
  import { livePanelStore } from '@/stores/socket/live-panel-socket.store';

  export default {
    components: {
      IconBox,
    },
    computed: {
      ...mapState(useDashboardStore, ['summaryTotals', 'filteredSummary', 'selectedQueues']),
      ...mapState(livePanelStore, ['queuesArray', 'calls']),

      filteredSummaryQueueNames() {
        return this.filteredSummary.map((item) => item.name);
      },

      filteredQueues() {
        return this.selectedQueues.length
          ? this.queuesArray.filter((queue) => this.selectedQueues.includes(queue.number))
          : this.queuesArray;
      },
      totalLoggedInAgents() {
        let loggedInAgents = new Set();
        for (const queue of this.filteredQueues) {
          Object.values(queue.agents).forEach((agent) => {
            if (agent.status !== 'unavailable') {
              loggedInAgents.add(agent.number);
            }
          });
        }

        return loggedInAgents.size;
      },

      totalAvailableAgents() {
        let loggedInAgents = new Set();
        for (const queue of this.filteredQueues) {
          Object.values(queue.agents).forEach((agent) => {
            if (!agent.isPaused && agent.status === 'idle') {
              loggedInAgents.add(agent.number);
            }
          });
        }

        return loggedInAgents.size;
      },
      totalAgents() {
        let agents = {};
        for (const queue of this.filteredQueues) {
          agents = { ...agents, ...queue.agents };
        }

        return Object.keys(agents).length;
      },
      totalWaitingCalls() {
        return this.filteredQueues.reduce((total, item) => total + parseInt(item.waitingCallsCount || 0), 0);
      },
      totalActiveCalls() {
        return this.filteredQueues.reduce((total, item) => total + item.activeCalls, 0);
      },
      avgTalkingTime() {
        return Math.round(this.summaryTotals.totalTalkTime / this.summaryTotals.answered) || 0;
      },

      avgWaitingTime() {
        return Math.round(this.summaryTotals.totalWaitTime / this.summaryTotals.total) || 0;
      },

      callAnalytics() {
        return [
          {
            title: this.totalWaitingCalls,
            text: this.$t('call_center.waiting_calls'),
            icon: waitingCalls,
            size: 'full',
          },
          {
            title: this.avgWaitingTime || 0,
            text: this.$t('call_center.average_waiting_time'),
            icon: averageWaitingTime,
            size: 'half',
            enableConvert: true,
          },
          {
            title: this.avgTalkingTime,
            text: this.$t('call_center.average_talking_time'),
            icon: averageTalkingTime,
            size: 'half',
            enableConvert: true,
          },
          {
            title: `${this.totalLoggedInAgents}/${this.totalAgents}`,
            text: this.$t('call_center.agents_logged_in'),
            icon: loggedIn,
            size: 'half',
          },
          {
            title: this.totalAvailableAgents,
            text: this.$t('call_center.available_agents'),
            icon: availableAgents,
            size: 'half',
          },
          {
            title: Object.keys(this.calls).length,
            text: this.$t('call_center.active_calls'),
            icon: activeCalls,
            size: 'half',
          },
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .boxes-parent {
    @include responsive(max, 1279.5px) {
      order: 3;
    }
  }
</style>
